import React, {ReactNode} from 'react';

import {useUnit} from 'effector-react';

import {userModel} from '@/entities/user/model';
import {UserRole} from '@/entities/user/types';

type Props = {
    roles: readonly UserRole[] | UserRole[];
    children: ReactNode;
};

export const PermissionAccess = ({roles, children}: Props) => {
    const user = useUnit(userModel);
    const hasPermissions = user.state.role && roles.includes(user.state.role);
    if (!hasPermissions) return <React.Fragment />;
    return <>{children}</>;
};
